import { Injectable, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AlertWindowComponent } from 'src/app/common/alert-window/alert-window.component';
import { FullSpinnerService } from 'src/app/common/full-spinner/full-spinner.service';
import { BatchStockdetailsComponent } from 'src/app/select-modal/batch-stockdetails/batch-stockdetails.component';
import { RatewiseCurrentstockComponent } from 'src/app/select-modal/ratewise-currentstock/ratewise-currentstock.component';
import { SelectSerialInvoiceComponent } from 'src/app/select-modal/select-serial-invoice/select-serial-invoice.component';
import { SelectserialStockreqNoitemComponent } from 'src/app/select-modal/selectserial-stockreq-noitem/selectserial-stockreq-noitem.component';
import { DataService } from 'src/app/service/data.service';
import { MultigodownSelectionComponent } from 'src/app/select-modal/multigodown-selection/multigodown-selection.component';
import { MatrixSelectionComponent } from 'src/app/select-modal/matrix-selection/matrix-selection.component';

@Injectable({
  providedIn: 'root'
})
export class DcNewService {
  id = '';
  fycode = '';
  brcode = '';
  godowns = [];
  responseData: any;
  scanbarcode = '';
  barcode = '';
  barcoderefn = '';
  loadingTrue = true;
  CloadingTrue = false;
  addloadingTrue = false;
  tableLoading = false;
  btnClicked = false;
  savebtnClicked = false;
  priceUpdate = false;
  editmode = false;
  CloseTicket = 'NO';
  salesamount: '';
  scanbarcodeid = '';
  customeradvances = [];
  searchItem = {
    type: 'NAME',
    text: ''
  };
  button = '';
  buttonEditTrue = false;
  customer = {
    advanced: {
      addressline01: '',
      addressline02: '',
      addressline03: '',
      addressline04: '',
      gstin: '',
      dob: '',
      dow: '',
      customergroupcode: '',
      countrycode: '',
      statecode: '',
      citycode: '',
      taxtype: '',
      gsttype: '',
      taxinclusive: '',
      pricetypecode: '',
      pricelistcode: '',
      discountlistcode: '',
      rewardrequired: '',
      cesscalculation: '',
      custcurrencycode: '',
      custcurrencyid: ''
    },
    partycontacts: [],
    customeraddresses: [],
    customercode: '',
    customerid: '',
    customername: '',
    mobileno: '',
    emailid: '',
    transdetails: {
      balancerewardpoints: '',
      balancerewardvalue: '',
      lastbilleddate: '',
      lastbilledvalue: '',
      yearbilledvalue: '',
      customerreceivables: ''
    },
  };
  currency = {
    currencycode: '',
    currencyid: '',
    currencyname: '',
    currencyvalue: '',
    decimalplaces: '',
    roundoff: ''
  };
  customercode = '';
  selectedItem = {
    ic: '',
    refn: '',
    ina: '',
    sr: '',
    srafterdisc: '',
    srorg: '',
    mrp: '',
    currencysrorg: '',
    value: '',
    valueorg: '',
    taxvalue: '',
    discvalue: '',
    srwithtax: '',
    valuewithtax: '',
    qty: '',
    dp: '',
    tc: '',
    tp: '',
    sq: '',
    fd: '',
    bc: '',
    sdp: '',
    schemediscvalue: '',
    serialnumbers: [],
    reffield2: [],
    reffield3: [],
    reffield4: [],
    reffield5: [],
    reffield6: [],
    reffield7: [],
    reffield8: [],
    reffield9: [],
    reffield10: [],
    serialgodowncodes: [],
    serialgodownnames: [],
    batchno: '',
    mfgdate: '',
    expdate: '',
    description: '',
    ac: '',
    mrp_profitper: '',
    mrp_profitamt: '',
    sr_profitper: '',
    sr_profitamt: '',
    description2: '',
    description3: '',
    description4: '',
    description5: '',
    cesspercent: '',
    cessamount: '',
    dispname: '',
    extracessrate: '',
    extracessamount: '',
    uom: '',
    sgstpercent: '',
    sgstamount: '',
    cgstpercent: '',
    cgstamount: '',
    igstpercent: '',
    igstamount: '',
    mfrname: '',
    hsncode: '',
    hsnrefno: '',
    matrix1code: '',
    matrix1id: '',
    matrix1name: '',
    matrix2code: '',
    matrix2id: '',
    matrix2name: '',
    matrix3code: '',
    matrix3d: '',
    matrix3name: '',
    matrix4code: '',
    matrix4id: '',
    matrix4name: '',
    matrix5code: '',
    matrix5id: '',
    matrix5name: '',
    matrix6code: '',
    matrix6id: '',
    matrix6name: '',
    matrix7code: '',
    matrix7id: '',
    matrix7name: '',
    matrix8code: '',
    matrix8id: '',
    matrix8name: '',
    matrix9code: '',
    matrix9id: '',
    matrix9name: '',
    matrix10code: '',
    matrix10id: '',
    matrix10name: '',
    reftype: '',
    salespersoncode: '',
    salespersonname: '',
    returnbalqty: '',
    dcbillbalqty: '',
    editbeforedetails: {
      srorg: '',
      batchno: '',
      bc: '',
      matrix1code: '',
      matrix2code: '',
      matrix3code: '',
      matrix4code: '',
      matrix5code: '',
      matrix6code: '',
      matrix7code: '',
      matrix8code: '',
      matrix9code: '',
      matrix10code: ''
    },
    godowndetail: [],
    ssr: ''
  };
  itemRestoreData = {
    ic: '',
    refn: '',
    qr: '',
    srorg: '',
    currencysrorg: '',
    mrp: '',
    value: '',
    valueorg: '',
    taxvalue: '',
    discvalue: '',
    srwithtax: '',
    srafterdisc: '',
    valuewithtax: '',
    qty: '',
    dp: '',
    tc: '',
    tp: '',
    sq: '',
    fd: '',
    bc: '',
    sdp: '',
    schemediscvalue: '',
    ac: '',
    mrp_profitper: '',
    mrp_profitamt: '',
    sr_profitper: '',
    sr_profitamt: '',
    sgstpercent: '',
    sgstamount: '',
    cgstpercent: '',
    cgstamount: '',
    igstpercent: '',
    igstamount: '',
    reftype: '',
    cesspercent: '',
    cessamount: '',
    extracessrate: '',
    extracessamount: ''
  };
  itemDetails = {
    serialdetails: {
      reffield2: {
        required: '',
        mandatory: ''
      },
      reffield3: {
        required: '',
        mandatory: ''
      },
      reffield4: {
        required: '',
        mandatory: ''
      },
      reffield5: {
        required: '',
        mandatory: ''
      },
      reffield6: {
        required: '',
        mandatory: ''
      },
      reffield7: {
        required: '',
        mandatory: ''
      },
      reffield8: {
        required: '',
        mandatory: ''
      },
      reffield9: {
        required: '',
        mandatory: ''
      },
      reffield10: {
        required: '',
        mandatory: ''
      },
      reffielddisplaycolumns: []
    },
    matrixsetup: {
      matrix1: {
        required: ''
      },
      matrix2: {
        required: ''
      },
      matrix3: {
        required: ''
      },
      matrix4: {
        required: ''
      },
      matrix5: {
        required: ''
      },
      matrix6: {
        required: ''
      },
      matrix7: {
        required: ''
      },
      matrix8: {
        required: ''
      },
      matrix9: {
        required: ''
      },
      matrix10: {
        required: ''
      },
      matrixheaddisplaycolumns: [],
      matrixnamedisplaycolumns: []
    },
    branchwiseminmaxstocks: [],
    branchwisemrpdiscounts: [],
    branchwisepricing: [],
    branchwiseproducts: [],
    multibarcodes: [],
    quantitypricesetup: {
      qtywisepricing: []
    },
    margindetails: {
      mrpmargindetails: {
        mrpdisc1per: '',
        mrpdisc2per: '',
        mrpmargin: '',
        mrpmarkupper: '',
        mrpmarkdownper: '',
        mrpnetmargin: '',
        mrpnetmarginper: ''
      },
      purchasedetails: {
        prdiscper: '',
        prtaxvalue: '',
        prwithtax: ''
      },
      salesmargindetails: {
        srdiscper: '',
        srwithouttax: '',
        srtaxvalue: '',
        srmargin: '',
        srmarkupper: '',
        srmarkdownper: '',
        srnetmargin: '',
        srnetmarginper: ''
      },
      priceschemes: {
        dlrpdiscper: '',
        dlrpmarginper: '',
        dlrpmarginvalue: '',
        p1discper: '',
        p1marginper: '',
        p1marginvalue: '',
        p2discper: '',
        p2marginper: '',
        p2marginvalue: '',
        p3discper: '',
        p3marginper: '',
        p3marginvalue: '',
        p4discper: '',
        p4marginper: '',
        p4marginvalue: '',
        p5discper: '',
        p5marginper: '',
        p5marginvalue: '',
        p6discper: '',
        p6marginper: '',
        p6marginvalue: ''
      },
      roundoffnetvalues: ''
    },

    ic: '',
    ina: '',
    refn: '',
    sr: '',
    tp: '',
    cc: '',
    dp: '',
    da: '',
    unit: '',
    itemactive: '',
    reftype: '',
    stkchk: '',
    hsncode: '',
    taxcode: '',
    sq: '',
    fd: '',
    uomcode: '',
    subuomcode: '',
    mpchk: '',
    pr: '',
    mrp: '',
    dlrp: '',
    bc: '',
    bcm: '',
    pcm: '',
    p1: '',
    p2: '',
    p3: '',
    p4: '',
    p5: '',
    p6: '',
    d1: '',
    d2: '',
    d3: '',
    d4: '',
    d5: '',
    d6: '',
    netwt: '',
    grswt: '',
    imc: '',
    ilc: '',
    origincode: '',
    onlineallowed: '',
    mfgdateyn: '',
    expdays: '',
    cc2: '',
    cc3: '',
    cc4: '',
    cc5: '',
    itemtypecode: '',
    cesspercent: '',
    extracessrate: ''
  };
  matrixsetup = {
    matrix1: {
      required: '',
      caption: ''
    },
    matrix2: {
      required: '',
      caption: ''
    },
    matrix3: {
      required: '',
      caption: ''
    },
    matrix4: {
      required: '',
      caption: ''
    },
    matrix5: {
      required: '',
      caption: ''
    },
    matrix6: {
      required: '',
      caption: ''
    },
    matrix7: {
      required: '',
      caption: ''
    },
    matrix8: {
      required: '',
      caption: ''
    },
    matrix9: {
      required: '',
      caption: ''
    },
    matrix10: {
      required: '',
      caption: ''
    },
  };
  dcData = {
    tempsalesno: '',
    displaysalesno: '',
    branchcode: '',
    finyearcode: '',
    customercode: '',
    customername: '',
    address: '',
    salesdate: moment().format('DD/MM/YYYY'),
    customerpo: '',
    customerpodate: '',
    creditdays: '',
    salesnotes: '',
    paymentterms: '',
    deliverymode: '',
    noofpackages: '',
    ewaybillrefno: '',
    salestypecode: '',
    salestypename: '',
    salesaccountcode: '',
    salesaccountname: '',
    receiptmodecode: '',
    receiptmodename: '',
    costcentercode: '',
    costcentername: '',
    salestaxtype: '',
    salestaxinclusive: '',
    salesgsttype: '',
    currencyexchangerate: '',
    salescurrencycode: '',
    salescurrencyid: '',
    salesnetcurrencyvalue: '',
    subtotalamount: '',
    subtotalamountorg: '',
    billdiscountpercent: '',
    billdiscountamount: '',
    netamount: '',
    cashamount: '',
    cardamount: '',
    creditamount: '',
    chequeamount: '',
    freeamount: '',
    couponamount: '',
    othercardamount: '',
    rewardspentamount: '',
    returnadjustamount: '',
    tempexchangeno: '',
    nextsalesreminddate: '',
    bankcode: '',
    bankname: '',
    refno: '',
    date: '',
    tenderedamount: '',
    balancetopay: '',
    creditcardno: '',
    ourbankcode: '',
    ourbankname: '',
    cardtypecode: '',
    cardholdername: '',
    cardtypename: '',
    cardcompanytypecode: '',
    cardcompanytypename: '',
    cardservicechargespercent: '',
    cardservicechargesvalue: '',
    despatchaddress1: '',
    despatchaddress2: '',
    despatchaddress3: '',
    despatchaddress4: '',
    salespersoncode: '',
    salespersonname: '',
    totaltax: '',
    totalsgst: '',
    totalcgst: '',
    totaligst: '',
    totalgst: '',
    totalcharges: '',
    roundoffamount: '',
    createdby: '',
    createddatetime: '',
    approved: '',
    approvedby: '',
    approveddatetime: '',
    approval_timetaken: '',
    approval_timeelapsed: '',
    srallowed: '',
    contactcode: '',
    contactname: '',
    contactno: '',
    emailid: '',
    workphoneno: '',
    department: '',
    designation: '',
    exchangeno: '',
    dcwithtax: '',
    dcreturnable: '',
    dcbillable: '',
    dcreturnduedate: '',
    invoiceallowed: '',
    basedonno: '',
    basedondate: '',
    basedonname: '',
    questioncode: '',
    questionanswer: '',
    holdbill: 'NO',
    addbybarcode: 'NO',
    totalqty: 0,
    walletbankcode: '',
    entryupdatemode: '',
    salesentrytypename: 'SALES_INVOICE',
    closedtickets: '',
    available_items: [],
    unavailable_items: [],
    charges: [],
    taxsummary: [],
    documents: [],
    termsandconditions: [],
    advanceadjustments: [],
    returnadjustments: [],
    coupondetails: [],
    items: [],
    coupontotalsummary: {
      couponcount: '',
      copuonvalue: '',
      chargesvalue: '',
      couponnetvalue: ''
    },
    ewaybilldetails: {
      transportmodecode: '',
      transportmodename: '',
      transportdistance: '',
      transportid: '',
      transportname: '',
      transportdocno: '',
      transportdate: '',
      vehicleno: '',
      vehicletypecode: '',
      vehicletypename: ''
    }
  };
  discounts = {
    billdiscountpercent: '',
    billdiscountamount: ''
  };
  defC: any = {
    allcolumns: {
      slno: {
        displayname: ''
      },
      ic: {
        displayname: ''
      },
      refn: {
        displayname: ''
      },
      ina: {
        displayname: ''
      },
      sr: {
        displayname: ''
      },
      srafterdisc: {
        displayname: ''
      },
      srorg: {
        displayname: ''
      },
      mrp: {
        displayname: ''
      },
      currencysrorg: {
        displayname: ''
      },
      value: {
        displayname: ''
      },
      valueorg: {
        displayname: ''
      },
      taxvalue: {
        displayname: ''
      },
      discvalue: {
        displayname: ''
      },
      srwithtax: {
        displayname: ''
      },
      valuewithtax: {
        displayname: ''
      },
      qty: {
        displayname: ''
      },
      dp: {
        displayname: ''
      },
      tc: {
        displayname: ''
      },
      tp: {
        displayname: ''
      },
      sq: {
        displayname: ''
      },
      fd: {
        displayname: ''
      },
      bc: {
        displayname: ''
      },
      sdp: {
        displayname: ''
      },
      schemediscvalue: {
        displayname: ''
      },
      batchno: {
        displayname: ''
      },
      mfgdate: {
        displayname: ''
      },
      expdate: {
        displayname: ''
      },
      description: {
        displayname: ''
      },
      ac: {
        displayname: ''
      },
      mrp_profitper: {
        displayname: ''
      },
      mrp_profitamt: {
        displayname: ''
      },
      sr_profitper: {
        displayname: ''
      },
      sr_profitamt: {
        displayname: ''
      },
      description2: {
        displayname: ''
      },
      description3: {
        displayname: ''
      },
      description4: {
        displayname: ''
      },
      description5: {
        displayname: ''
      },
      cesspercent: {
        displayname: ''
      },
      cessamount: {
        displayname: ''
      },
      dispname: {
        displayname: ''
      },
      extracessrate: {
        displayname: ''
      },
      extracessamount: {
        displayname: ''
      },
      uom: {
        displayname: ''
      },
      sgstpercent: {
        displayname: ''
      },
      sgstamount: {
        displayname: ''
      },
      cgstpercent: {
        displayname: ''
      },
      cgstamount: {
        displayname: ''
      },
      igstpercent: {
        displayname: ''
      },
      igstamount: {
        displayname: ''
      },
      mfrname: {
        displayname: ''
      },
      hsncode: {
        displayname: ''
      },
      hsnrefno: {
        displayname: ''
      },
      matrix1id: {
        displayname: ''
      },
      matrix1name: {
        displayname: ''
      },
      matrix2id: {
        displayname: ''
      },
      matrix2name: {
        displayname: ''
      },
      matrix3id: {
        displayname: ''
      },
      matrix3name: {
        displayname: ''
      },
      matrix4id: {
        displayname: ''
      },
      matrix4name: {
        displayname: ''
      },
      matrix5id: {
        displayname: ''
      },
      matrix5name: {
        displayname: ''
      },
      matrix6id: {
        displayname: ''
      },
      matrix6name: {
        displayname: ''
      },
      matrix7id: {
        displayname: ''
      },
      matrix7name: {
        displayname: ''
      },
      matrix8id: {
        displayname: ''
      },
      matrix8name: {
        displayname: ''
      },
      matrix9id: {
        displayname: ''
      },
      matrix9name: {
        displayname: ''
      },
      matrix10id: {
        displayname: ''
      },
      matrix10name: {
        displayname: ''
      },
      reftype: {
        displayname: ''
      },
      salespersoncode: {
        displayname: ''
      },
      salespersonname: {
        displayname: ''
      }
    },
    displaycolumns: []
  };
  displayColumn: any = [];
  batchstocks = '';
  constructSerials = [];
  xbilldiscount = '';
  xbilldiscamount = '';
  xrate = '';
  xdisc = '';
  xqty = '';
  getDataObservable: Subject<any> = new Subject();
  @ViewChild('ic', { static: false }) ic;
  constructor(
    public storage: Storage,
    public data: DataService,
    public dialog: MatDialog,
    public router: Router,
    public fullspinner: FullSpinnerService
  ) { }

  
  getDefaultValue() {
    if (this.data.token !== '') {
      this.tableLoading = true;
      this.data.getData('screencolumn/dc').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.defC = this.responseData.data;
          this.defC.displaycolumns.push('remove');
        }
        this.tableLoading = false;
      }, (error) => {
        this.tableLoading = false;
      });
    } else {
      setTimeout(() => {
        this.getDefaultValue();
      }, 400);
    }
  }

  checkForPending() {
    this.storage.get('dcData').then((val) => {
      if (val) {
        this.draftItemRestore(val);
      } else {
        setTimeout(() => {
          this.clearAllTempData();
        }, 400);
        this.getDCDefaultData();
      }
    });
  }

  draftItemRestore(el): void {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: 'Do you want to restore the draft DC '
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.storage.get('dcTicketClose').then((val) => {
          if (val) { this.CloseTicket = val; }
        });
        this.getTempData(el.tempsalesno);
      } else {
        this.clearAllTempData();
        this.storage.remove('dcData');
        setTimeout(() => {
          this.getDCDefaultData();
        }, 400);
      }
    });
  }

  getTempData(tempid): void {
    this.addloadingTrue = true;
    const obj = {
      "entryno": tempid,
      "entryfinyearcode": this.fycode,
      "entrybranchcode": this.brcode,
      "salesentrytypename": "DC"
    };
    this.data.postData('sales/detail', obj).then((success) => {
      // this.data.getData('sales/' + tempid + '/detail').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.dcData = this.responseData.data;
        this.discounts.billdiscountpercent = this.responseData.data.billdiscountpercent;
        this.discounts.billdiscountamount = this.responseData.data.billdiscountamount;
        this.loadingTrue = false;
        this.storage.set('dcData', this.dcData);
        this.customercode = this.dcData.customercode;
        this.customerChanged(false);
      } else {
        this.clearAll();
        this.clearAllTempData();
      }
    }, (error) => {
      this.addloadingTrue = false;
    });
  }

  getDCDefaultData() {
    if (this.data.token !== '') {
      this.loadingTrue = true;
      const obj = {
        "entryno": '0',
        "entryfinyearcode": this.fycode,
        "entrybranchcode": this.brcode,
        "salesentrytypename": "DC"
      };
      this.data.postData('sales/detail', obj).then((success) => {
        // this.data.getData('sales/0/detail').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.dcData = this.responseData.data;
          this.discounts.billdiscountpercent = this.responseData.data.billdiscountpercent;
          this.discounts.billdiscountamount = this.responseData.data.billdiscountamount;
          this.loadingTrue = false;
          this.dcData.customercode = '';
          this.dcData.tempsalesno = '';
          this.dcData.dcwithtax = 'NO';
          this.customercode = this.dcData.customercode;
          this.getDCReturnable();
          // this.clearSelectedItem();
        } else {
          this.clearAll();
          this.clearAllTempData();
        }
      }, (error) => {
        this.loadingTrue = false;
      });
    } else {
      setTimeout(() => {
        this.getDCDefaultData();
      }, 400);
    }
  }

  getDCReturnable() {
    if (this.dcData.dcbillable === 'YES') {
      this.dcData.dcreturnable = 'NO';
    } else {
      this.dcData.dcreturnable = 'YES';
    }
  }

  customerChanged(val): void {
    if (this.customercode !== '') {
      this.CloadingTrue = true;
      this.data.getData('customer/' + this.customercode + '/withdetails').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.customer = this.responseData.data;
          this.dcData.customercode = this.customer.customercode;
          if (val) {
            this.dcData.salestaxtype = this.customer.advanced.taxtype;
          }
          if (this.customer.customeraddresses.length === 0) {
            this.dcData.despatchaddress1 = this.customer.advanced.addressline01;
            this.dcData.despatchaddress2 = this.customer.advanced.addressline02;
            this.dcData.despatchaddress3 = this.customer.advanced.addressline03;
            this.dcData.despatchaddress4 = this.customer.advanced.addressline04;
          } else {
            this.dcData.despatchaddress1 = this.customer.customeraddresses[0].address1;
            this.dcData.despatchaddress2 = this.customer.customeraddresses[0].address2;
            this.dcData.despatchaddress3 = this.customer.customeraddresses[0].address3;
            this.dcData.despatchaddress4 = this.customer.customeraddresses[0].address4;
          }
          setTimeout(() => {
            this.getCurrenyDetails(val);
          }, 400);
          this.CloadingTrue = false;
        }
      }, (error) => { });
    }
  }

  getCurrenyDetails(value) {
    this.storage.get('authorizationResponse').then((val) => {
      if (val) {
        if (val.softwaresetup.data.multicurrencyonsales === 'YES') {
          this.data.getData('currency/' + this.customer.advanced.custcurrencycode).then((success) => {
            this.responseData = success;
            if (this.responseData.Status === true) {
              this.currency = this.responseData.data;
              if (value) {
                this.dcData.salescurrencycode = this.customer.advanced.custcurrencycode;
                this.dcData.currencyexchangerate = this.currency.currencyvalue;
              }
            } else {
              this.currency = {
                currencycode: '',
                currencyid: '',
                currencyname: '',
                currencyvalue: '',
                decimalplaces: '',
                roundoff: ''
              };
            }
          }, (error) => { });
        }
      }
    });
  }

  UpdateOtherDetails() {
    this.data.postData('update/sales/otherdetails', this.dcData).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        // this.storage.set('pData', this.pData);
      }
    }, (error) => { });
  }

  clearAll() {
    this.customer = {
      advanced: {
        addressline01: '',
        addressline02: '',
        addressline03: '',
        addressline04: '',
        gstin: '',
        dob: '',
        dow: '',
        customergroupcode: '',
        countrycode: '',
        statecode: '',
        citycode: '',
        taxtype: '',
        gsttype: '',
        taxinclusive: '',
        pricetypecode: '',
        pricelistcode: '',
        discountlistcode: '',
        rewardrequired: '',
        cesscalculation: '',
        custcurrencycode: '',
        custcurrencyid: ''
      },
      partycontacts: [],
      customeraddresses: [],
      customercode: '',
      customerid: '',
      customername: '',
      mobileno: '',
      emailid: '',
      transdetails: {
        balancerewardpoints: '',
        balancerewardvalue: '',
        lastbilleddate: '',
        lastbilledvalue: '',
        yearbilledvalue: '',
        customerreceivables: ''
      },
    };
    this.customercode = '';
    this.loadingTrue = false;
    this.clearSelectedItem();
    this.clearItemDetails();
    this.clearItemRestoreDetails();
    this.clearDCData();
    this.getDCDefaultData();
  }

  clearSelectedItem() {
    this.selectedItem = {
      ic: '',
      refn: '',
      ina: '',
      sr: '',
      srafterdisc: '',
      srorg: '',
      mrp: '',
      currencysrorg: '',
      value: '',
      valueorg: '',
      taxvalue: '',
      discvalue: '',
      srwithtax: '',
      valuewithtax: '',
      qty: '',
      dp: '',
      tc: '',
      tp: '',
      sq: '',
      fd: '',
      bc: '',
      sdp: '',
      schemediscvalue: '',
      serialnumbers: [],
      reffield2: [],
      reffield3: [],
      reffield4: [],
      reffield5: [],
      reffield6: [],
      reffield7: [],
      reffield8: [],
      reffield9: [],
      reffield10: [],
      serialgodowncodes: [],
      serialgodownnames: [],
      batchno: '',
      mfgdate: '',
      expdate: '',
      description: '',
      ac: '',
      mrp_profitper: '',
      mrp_profitamt: '',
      sr_profitper: '',
      sr_profitamt: '',
      description2: '',
      description3: '',
      description4: '',
      description5: '',
      cesspercent: '',
      cessamount: '',
      dispname: '',
      extracessrate: '',
      extracessamount: '',
      uom: '',
      sgstpercent: '',
      sgstamount: '',
      cgstpercent: '',
      cgstamount: '',
      igstpercent: '',
      igstamount: '',
      mfrname: '',
      hsncode: '',
      hsnrefno: '',
      matrix1code: '',
      matrix1id: '',
      matrix1name: '',
      matrix2code: '',
      matrix2id: '',
      matrix2name: '',
      matrix3code: '',
      matrix3d: '',
      matrix3name: '',
      matrix4code: '',
      matrix4id: '',
      matrix4name: '',
      matrix5code: '',
      matrix5id: '',
      matrix5name: '',
      matrix6code: '',
      matrix6id: '',
      matrix6name: '',
      matrix7code: '',
      matrix7id: '',
      matrix7name: '',
      matrix8code: '',
      matrix8id: '',
      matrix8name: '',
      matrix9code: '',
      matrix9id: '',
      matrix9name: '',
      matrix10code: '',
      matrix10id: '',
      matrix10name: '',
      reftype: '',
      salespersoncode: '',
      salespersonname: '',
      returnbalqty: '',
      dcbillbalqty: '',
      editbeforedetails: {
        srorg: '',
        batchno: '',
        bc: '',
        matrix1code: '',
        matrix2code: '',
        matrix3code: '',
        matrix4code: '',
        matrix5code: '',
        matrix6code: '',
        matrix7code: '',
        matrix8code: '',
        matrix9code: '',
        matrix10code: ''
      },
      godowndetail: [],
      ssr: ''
    };
  }

  clearItemDetails() {
    this.itemDetails = {
      serialdetails: {
        reffield2: {
          required: '',
          mandatory: ''
        },
        reffield3: {
          required: '',
          mandatory: ''
        },
        reffield4: {
          required: '',
          mandatory: ''
        },
        reffield5: {
          required: '',
          mandatory: ''
        },
        reffield6: {
          required: '',
          mandatory: ''
        },
        reffield7: {
          required: '',
          mandatory: ''
        },
        reffield8: {
          required: '',
          mandatory: ''
        },
        reffield9: {
          required: '',
          mandatory: ''
        },
        reffield10: {
          required: '',
          mandatory: ''
        },
        reffielddisplaycolumns: []
      },
      matrixsetup: {
        matrix1: {
          required: ''
        },
        matrix2: {
          required: ''
        },
        matrix3: {
          required: ''
        },
        matrix4: {
          required: ''
        },
        matrix5: {
          required: ''
        },
        matrix6: {
          required: ''
        },
        matrix7: {
          required: ''
        },
        matrix8: {
          required: ''
        },
        matrix9: {
          required: ''
        },
        matrix10: {
          required: ''
        },
        matrixheaddisplaycolumns: [],
        matrixnamedisplaycolumns: []
      },
      branchwiseminmaxstocks: [],
      branchwisemrpdiscounts: [],
      branchwisepricing: [],
      branchwiseproducts: [],
      multibarcodes: [],
      quantitypricesetup: {
        qtywisepricing: []
      },
      margindetails: {
        mrpmargindetails: {
          mrpdisc1per: '',
          mrpdisc2per: '',
          mrpmargin: '',
          mrpmarkupper: '',
          mrpmarkdownper: '',
          mrpnetmargin: '',
          mrpnetmarginper: ''
        },
        purchasedetails: {
          prdiscper: '',
          prtaxvalue: '',
          prwithtax: ''
        },
        salesmargindetails: {
          srdiscper: '',
          srwithouttax: '',
          srtaxvalue: '',
          srmargin: '',
          srmarkupper: '',
          srmarkdownper: '',
          srnetmargin: '',
          srnetmarginper: ''
        },
        priceschemes: {
          dlrpdiscper: '',
          dlrpmarginper: '',
          dlrpmarginvalue: '',
          p1discper: '',
          p1marginper: '',
          p1marginvalue: '',
          p2discper: '',
          p2marginper: '',
          p2marginvalue: '',
          p3discper: '',
          p3marginper: '',
          p3marginvalue: '',
          p4discper: '',
          p4marginper: '',
          p4marginvalue: '',
          p5discper: '',
          p5marginper: '',
          p5marginvalue: '',
          p6discper: '',
          p6marginper: '',
          p6marginvalue: ''
        },
        roundoffnetvalues: ''
      },

      ic: '',
      ina: '',
      refn: '',
      sr: '',
      tp: '',
      cc: '',
      dp: '',
      da: '',
      unit: '',
      itemactive: '',
      reftype: '',
      stkchk: '',
      hsncode: '',
      taxcode: '',
      sq: '',
      fd: '',
      uomcode: '',
      subuomcode: '',
      mpchk: '',
      pr: '',
      mrp: '',
      dlrp: '',
      bc: '',
      bcm: '',
      pcm: '',
      p1: '',
      p2: '',
      p3: '',
      p4: '',
      p5: '',
      p6: '',
      d1: '',
      d2: '',
      d3: '',
      d4: '',
      d5: '',
      d6: '',
      netwt: '',
      grswt: '',
      imc: '',
      ilc: '',
      origincode: '',
      onlineallowed: '',
      mfgdateyn: '',
      expdays: '',
      cc2: '',
      cc3: '',
      cc4: '',
      cc5: '',
      itemtypecode: '',
      cesspercent: '',
      extracessrate: ''
    };
    this.constructSerials = [];
  }

  clearDCData() {
    this.dcData = {
      tempsalesno: '',
      displaysalesno: '',
      branchcode: '',
      finyearcode: '',
      customercode: '',
      customername: '',
      address: '',
      salesdate: moment().format('DD/MM/YYYY'),
      customerpo: '',
      customerpodate: '',
      creditdays: '',
      salesnotes: '',
      paymentterms: '',
      deliverymode: '',
      noofpackages: '',
      ewaybillrefno: '',
      salestypecode: '',
      salestypename: '',
      salesaccountcode: '',
      salesaccountname: '',
      receiptmodecode: '',
      receiptmodename: '',
      costcentercode: '',
      costcentername: '',
      salestaxtype: '',
      salestaxinclusive: '',
      salesgsttype: '',
      currencyexchangerate: '',
      salescurrencycode: '',
      salescurrencyid: '',
      salesnetcurrencyvalue: '',
      subtotalamount: '',
      subtotalamountorg: '',
      billdiscountpercent: '',
      billdiscountamount: '',
      netamount: '',
      cashamount: '',
      cardamount: '',
      creditamount: '',
      chequeamount: '',
      freeamount: '',
      couponamount: '',
      othercardamount: '',
      rewardspentamount: '',
      returnadjustamount: '',
      tempexchangeno: '',
      nextsalesreminddate: '',
      bankcode: '',
      bankname: '',
      refno: '',
      date: '',
      tenderedamount: '',
      balancetopay: '',
      creditcardno: '',
      ourbankcode: '',
      ourbankname: '',
      cardtypecode: '',
      cardholdername: '',
      cardtypename: '',
      cardcompanytypecode: '',
      cardcompanytypename: '',
      cardservicechargespercent: '',
      cardservicechargesvalue: '',
      despatchaddress1: '',
      despatchaddress2: '',
      despatchaddress3: '',
      despatchaddress4: '',
      salespersoncode: '',
      salespersonname: '',
      totaltax: '',
      totalsgst: '',
      totalcgst: '',
      totaligst: '',
      totalgst: '',
      totalcharges: '',
      roundoffamount: '',
      createdby: '',
      createddatetime: '',
      approved: '',
      approvedby: '',
      approveddatetime: '',
      approval_timetaken: '',
      approval_timeelapsed: '',
      srallowed: '',
      contactcode: '',
      contactname: '',
      contactno: '',
      emailid: '',
      workphoneno: '',
      department: '',
      designation: '',
      exchangeno: '',
      dcwithtax: '',
      dcreturnable: '',
      dcbillable: '',
      dcreturnduedate: '',
      invoiceallowed: '',
      basedonno: '',
      basedondate: '',
      basedonname: '',
      questioncode: '',
      questionanswer: '',
      holdbill: 'NO',
      addbybarcode: 'NO',
      totalqty: 0,
      walletbankcode: '',
      entryupdatemode: '',
      salesentrytypename: 'DC',
      closedtickets: '',
      available_items: [],
      unavailable_items: [],
      charges: [],
      taxsummary: [],
      documents: [],
      termsandconditions: [],
      advanceadjustments: [],
      returnadjustments: [],
      coupondetails: [],
      items: [],
      coupontotalsummary: {
        couponcount: '',
        copuonvalue: '',
        chargesvalue: '',
        couponnetvalue: ''
      },
      ewaybilldetails: {
        transportmodecode: '',
        transportmodename: '',
        transportdistance: '',
        transportid: '',
        transportname: '',
        transportdocno: '',
        transportdate: '',
        vehicleno: '',
        vehicletypecode: '',
        vehicletypename: ''
      }
    };
    this.storage.remove('dcData');
  }

  clearAllTempData() {
    this.data.deleteData('draftstocks/clear').then((success) => {
    }, (error) => { });
    this.storage.remove('dcTicketClose');
  }

  clearItemRestoreDetails() {
    this.itemRestoreData = {
      ic: '',
      refn: '',
      qr: '',
      srorg: '',
      currencysrorg: '',
      mrp: '',
      value: '',
      valueorg: '',
      taxvalue: '',
      discvalue: '',
      srwithtax: '',
      srafterdisc: '',
      valuewithtax: '',
      qty: '',
      dp: '',
      tc: '',
      tp: '',
      sq: '',
      fd: '',
      bc: '',
      sdp: '',
      schemediscvalue: '',
      ac: '',
      mrp_profitper: '',
      mrp_profitamt: '',
      sr_profitper: '',
      sr_profitamt: '',
      sgstpercent: '',
      sgstamount: '',
      cgstpercent: '',
      cgstamount: '',
      igstpercent: '',
      igstamount: '',
      reftype: '',
      cesspercent: '',
      cessamount: '',
      extracessrate: '',
      extracessamount: ''
    };
  }

  // Get the Item Details and Item Restore Data;
  getData(val, xic, restore, xbc) {
    this.CloadingTrue = val;
    // Getting the Item Details Data
    this.data.getData('item/' + xic + '/withdetails').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.itemDetails = this.responseData.data;
        this.selectedItem.ina = this.itemDetails.ina;
        if (restore) {
          this.getItemRestoreData(this.CloadingTrue, xic, xbc);
        } else {
          this.CloadingTrue = false;
          this.callPopupfn();
        }

      } else {
        this.clearItemDetails();
      }
    }, (error) => {
      this.CloadingTrue = false;
    });
  }

  // Getting Item Restore Data
  getItemRestoreData(val, xic, xbc) {

    this.fullspinner.spin.next(true);
    if (this.barcode === 'BARCODE') {
      xbc = this.ic.barcoderefn;
    }
    const obj = {
      tempsalesno: this.dcData.tempsalesno,
      customercode: this.customer.customercode,
      salesentrytypename: 'DC',
      salestaxtype: this.dcData.salestaxtype,
      salestaxinclusive: this.customer.advanced.taxinclusive,
      salesgsttype: this.dcData.salesgsttype,
      currencyexchangerate: this.dcData.currencyexchangerate,
      salescurrencycode: this.dcData.salescurrencycode,
      salespersoncode: this.dcData.salespersoncode,
      ratemodecode: 0,
      items: [
        {
          ic: xic,
          bc: xbc
        }
      ]
    };
    this.data.postData('sales/itemrestore', obj).then((success) => {
      this.responseData = success;
      this.fullspinner.spin.next(false);
      if (this.responseData.Status === true) {
        this.itemRestoreData = this.responseData.data;
        this.selectedItem.qty = this.itemRestoreData.qty;
        setTimeout(() => {
          this.callPopupfn();
          // tslint:disable-next-line: prefer-const
          let data = {};
          const setData = Object.assign(data, this.itemRestoreData);
          this.setItemRestoreDetails(data);
          if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
            this.doConstructSerial();
          }
        }, 100);
        this.loadingTrue = false;
      } else {
        this.data.openAlert(this.responseData);
        this.clearItemRestoreDetails();
        this.loadingTrue = false;
      }
    }, (error) => {
      this.loadingTrue = false;
    });
  }

  // set Item Resore Data with Selected Item
  setItemRestoreDetails(icrd) {
    this.clearSelectedItem();
    this.selectedItem.ina = this.itemDetails.ina;
    this.selectedItem.hsncode = this.itemDetails.hsncode;
    for (const key in this.selectedItem) {
      if (icrd[key]) {
        if (this.selectedItem[key] === icrd[key]) {
          continue;
        } else {
          this.selectedItem[key] = icrd[key];
        }
      }
    }
  }

  callPopupfn() {
    if (this.itemDetails.reftype === 'BATCH') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') {
        this.selectGodown();
      } else {
        this.getBatchStockDetails();
      }

    } else if (this.itemDetails.reftype === 'NONE' && this.itemDetails.stkchk === 'YES' && this.itemDetails.mpchk === 'YES') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') {
        this.selectGodown();
      } else {
        this.viewRatewiseStock();
      }

    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'YES') {
      this.getSerialItem(true);
    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
      this.getStockReqNoItem();
    } else if (this.itemDetails.reftype === 'NONE' && this.itemDetails.stkchk === 'YES' && this.itemDetails.mpchk === 'NO') {
      this.selectGodown();
    } else if (this.itemDetails.reftype === 'MATRIX') {
      // this.selectGodown();
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto'  || (this.barcode === 'BARCODE' && this.itemDetails.bcm === 'Auto')) {
        this.selectGodown();
      } else {
        this.getMatrix();
      }

    }
  }

  doSubmit() {
    if (this.dcData.tempsalesno !== '') {
      this.btnClicked = true;
      this.dcData.salesentrytypename = 'DC';
      this.storage.get('dcTicketClose').then((val) => {
        if (val) { this.dcData.closedtickets = val; } else { this.dcData.closedtickets = 'NO'; }
      });
      setTimeout(() => {
        this.doConfirm();
      }, 500);
    }
  }
  doConfirm() {
    this.dcData.salestaxinclusive = this.customer.advanced.taxinclusive;
    this.dcData.salestaxtype = this.customer.advanced.taxtype;
    this.dcData.salesgsttype = this.customer.advanced.gsttype;
    this.data.postData('sales/confirm', this.dcData).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.clearAll();
        this.data.openAlert(this.responseData);
        this.btnClicked = false;
        const routeId = this.responseData.salesno;
        this.router.navigateByUrl('/home/sales/dc/details/' + routeId + '/' + this.fycode + '/' + this.brcode);
      } else {
        if (this.responseData.questioncode) {
          if (parseFloat(this.responseData.questioncode) > 0) {
            this.doAskQuestion(this.responseData);
          } else {
            this.data.openAlert(this.responseData);
            this.btnClicked = false;
          }
        } else {
          this.data.openAlert(this.responseData);
          this.btnClicked = false;
        }
      }
    }, (error) => {
    });
  }

  doAskQuestion(val) {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: val.Message,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dcData.questioncode = val.questioncode;
        this.dcData.questionanswer = 'YES';
        this.doSubmit();
      } else if (!result) {
        this.btnClicked = false;
      }
    });
  }

  doUpdateCharges(): void {
    this.btnClicked = true;
    const obj = {
      tempsalesno: this.dcData.tempsalesno,
      billdiscountpercent: this.dcData.billdiscountpercent,
      billdiscountamount: this.dcData.billdiscountamount,
      roundoffamount: this.dcData.roundoffamount,
      charges: this.dcData.charges
    };
    this.data.postData('sales/discountandcharges', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.getTempData(this.dcData.tempsalesno);
        this.btnClicked = false;
      }
      this.data.openAlert(this.responseData);
      this.btnClicked = false;
    }, (error) => {

    });
  }

  getSingleData(tempid) {
    if (this.data.token !== '') {
      this.loadingTrue = true;
      const obj = {
        "entryno": tempid,
        "entryfinyearcode": this.fycode,
        "entrybranchcode": this.brcode,
        "salesentrytypename": "DC"
      };
      this.data.postData('sales/detail', obj).then((success) => {
        // this.data.getData('sales/' + tempid + '/detail').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.loadingTrue = false;
          this.dcData = this.responseData.data;
          this.customercode = this.dcData.customercode;
          this.customerChanged(false);
        } else {
          this.clearAll();
          this.clearAllTempData();
        }
        this.loadingTrue = false;
      }, (error) => {

      });
    } else {
      setTimeout(() => {
        this.getSingleData(tempid);
      }, 400);
    }
  }

  doUpdateRoundoff() {
    this.btnClicked = true;
    const obj = {
      tempsalesno: this.dcData.tempsalesno,
      roundoffamount: this.dcData.roundoffamount
    };
    this.data.postData('sales/roundoff', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.getTempData(this.dcData.tempsalesno);
        this.btnClicked = false;
      }
      this.data.openAlert(this.responseData);
      this.btnClicked = false;
    }, (error) => {

    });
  }

  updateRate() {
    if (parseFloat(this.selectedItem.qty) > 0) {
      if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
        this.selectedItem.srorg = '';
      }
      this.fullspinner.spin.next(true);
      this.priceUpdate = true;
      const salesData = JSON.parse(JSON.stringify(this.dcData));
      salesData.salesentrytypename = 'DC';
      salesData.salestaxinclusive = this.customer.advanced.taxinclusive;
      salesData.salestaxtype = this.dcData.salestaxtype;
      salesData.salesgsttype = this.dcData.salesgsttype;
      salesData.items = [];
      salesData.items.push(this.selectedItem);
      this.data.postData('sales/calculate/itemvalues', salesData).then((success) => {
        this.responseData = success;
        this.fullspinner.spin.next(false);
        if (this.responseData.Status === true) {
          const xydata = JSON.parse(JSON.stringify(this.selectedItem));
          if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
            this.xrate = xydata.currencysrorg;
          } else {
            this.xrate = xydata.srorg;
          }
          this.xdisc = xydata.dp;
          this.xqty = xydata.qty;
          this.priceUpdate = false;
          this.updateJson(this.responseData.data);
        } else {
          this.priceUpdate = false;
          this.data.openAlert(this.responseData);
        }
      }, (error) => {

      });
    }
  }

  updateJson(newvalue) {
    for (const key in this.selectedItem) {
      if (newvalue[key]) {
        if (this.selectedItem[key] === newvalue[key]) {
          continue;
        } else {
          this.selectedItem[key] = newvalue[key];
        }
      }
    }
  }

  getBatchStockDetails(): void {
    const dialogRef = this.dialog.open(BatchStockdetailsComponent, {
      width: '700px',
      data: {
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        entryname: '',
        supplierDC: 'NO',
        scanbarcode: this.scanbarcode,
        bc: this.scanbarcodeid,
        barcode: this.barcode,
        bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.batchno = result.selectedbill.batchno;
        this.selectedItem.srorg = result.selectedbill.salerate;
        if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
          this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.salerate) / parseFloat(this.dcData.currencyexchangerate)).toString();
        }
        this.batchstocks = result.selectedbill.stock;
        if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
          if (result.selectedbill.batchno === '') { this.selectGodown(); }
          this.selectedItem.godowndetail = result.selectedbill.godowndetails;
          this.selectedItem.qty = result.qty;
        }
        this.updateRate();
      } else { this.selectGodown(); }
    });
  }

  viewRatewiseStock(): void {
    const dialogRef = this.dialog.open(RatewiseCurrentstockComponent, {
      width: '500px',
      data: {
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        reftype: this.itemDetails.reftype,
        matrix1code: this.selectedItem.matrix1code,
        matrix2code: this.selectedItem.matrix2code,
        matrix3code: this.selectedItem.matrix3code,
        matrix4code: this.selectedItem.matrix4code,
        matrix5code: this.selectedItem.matrix5code,
        matrix6code: this.selectedItem.matrix6code,
        matrix7code: this.selectedItem.matrix7code,
        matrix8code: this.selectedItem.matrix8code,
        matrix9code: this.selectedItem.matrix9code,
        matrix10code: this.selectedItem.matrix10code,
        scanbarcode: this.scanbarcode,
        bc: this.scanbarcodeid,
        barcode: this.barcode,
        bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.ssr = result.selectedbill.sr;
        this.selectedItem.srorg = result.selectedbill.sr;
        if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
          this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.sr) / parseFloat(this.dcData.currencyexchangerate)).toString();
        }
        this.batchstocks = result.selectedbill.qty;
        if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
          if (result.selectedbill.sr === '') { this.selectGodown(); }
          this.selectedItem.godowndetail = result.selectedbill.godowndetails;
          this.selectedItem.qty = result.qty;

        }
        this.updateRate();
      } else { this.selectGodown(); }
    });
  }

  selectGodown(): void {
    if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
      const dialogRef = this.dialog.open(MultigodownSelectionComponent, {
        width: '700px',
        data: {
          ic: this.selectedItem.ic,
          ina: this.selectedItem.ina,
          qty: this.selectedItem.qty,
          godowndetail: this.selectedItem.godowndetail,
          entryname: 'DC',
          scanbarcode: this.scanbarcode,
          sbc: this.scanbarcodeid,
          barcode: this.barcode,
          bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.selectedItem.godowndetail = result.godowndetail;
          this.selectedItem.qty = result.qty;
          this.updateRate();
        }
      });
    }
  }

  getSerialItem(val): void {
    this.buttonEditTrue = false;
    if (this.button === 'Edit') {
      this.buttonEditTrue = true;
    }
    const dialogRef = this.dialog.open(SelectSerialInvoiceComponent, {
      width: '600px',
      data: {
        ic: this.selectedItem.ic,
        serialnumbers: this.selectedItem.serialnumbers,
        ina: this.selectedItem.ina,
        godowncodes: this.selectedItem.serialgodowncodes,
        godownnames: this.selectedItem.serialgodownnames,
        qty: this.selectedItem.qty,
        basedonname: this.dcData.basedonname, 
        entryname: 'DC',
        entryno: this.dcData.tempsalesno,
        entrybranchcode: this.brcode,
        entryfinyearcode: this.fycode,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.serialnumbers = result.selectedserial;
        this.selectedItem.qty = result.selectedserial.length;
        this.selectedItem.ssr = result.salerate;
        if (this.buttonEditTrue === false) {
          this.selectedItem.srorg = result.salerate;
        }
        if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
          if (this.buttonEditTrue === false) {
            this.selectedItem.currencysrorg = (parseFloat(result.salerate) / parseFloat(this.dcData.currencyexchangerate)).toString();
          }
        }
        this.selectedItem.serialgodowncodes = result.selectedserialgodowncodes;
        this.updateRate();
      }
      this.getDataObservable.next({ response: true, type: 'serial' });
    });
  }

  getStockReqNoItem(): void {
    const dialogRef = this.dialog.open(SelectserialStockreqNoitemComponent, {
      width: '500px',
      data: {
        ic: this.selectedItem.ic,
        constructSerials: this.constructSerials,
        ina: this.selectedItem.ina,
        qty: this.selectedItem.qty
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.serialnumbers = result.itemData.serialstocks.serialnumbers;
        this.selectedItem.reffield2 = result.itemData.serialstocks.reffield2;
        this.selectedItem.reffield3 = result.itemData.serialstocks.reffield3;
        this.selectedItem.reffield4 = result.itemData.serialstocks.reffield4;
        this.selectedItem.reffield5 = result.itemData.serialstocks.reffield5;
        this.selectedItem.reffield6 = result.itemData.serialstocks.reffield6;
        this.selectedItem.reffield7 = result.itemData.serialstocks.reffield7;
        this.selectedItem.reffield8 = result.itemData.serialstocks.reffield8;
        this.selectedItem.reffield9 = result.itemData.serialstocks.reffield9;
        this.selectedItem.reffield10 = result.itemData.serialstocks.reffield10;
        this.selectedItem.qty = result.construct.length;
      }
      this.getDataObservable.next({ response: true, type: 'serial' });
    });
  }

  exractSerial() {
    return new Promise((res, rej) => {
      let yesConstruct = false;
      if (this.itemDetails.reftype === 'SERIAL') {
        this.selectedItem.serialnumbers = [];
        this.selectedItem.serialgodowncodes = [];
        this.selectedItem.reffield2 = [];
        this.selectedItem.reffield3 = [];
        this.selectedItem.reffield4 = [];
        this.selectedItem.reffield5 = [];
        this.selectedItem.reffield6 = [];
        this.selectedItem.reffield6 = [];
        this.selectedItem.reffield7 = [];
        this.selectedItem.reffield8 = [];
        this.selectedItem.reffield9 = [];
        this.selectedItem.reffield10 = [];
        this.constructSerials.forEach(element => {
          this.selectedItem.serialnumbers.push(element.serialnumbers);
          this.selectedItem.reffield2.push(element.reffield2);
          this.selectedItem.reffield3.push(element.reffield3);
          this.selectedItem.reffield4.push(element.reffield4);
          this.selectedItem.reffield5.push(element.reffield5);
          this.selectedItem.reffield6.push(element.reffield6);
          this.selectedItem.reffield7.push(element.reffield7);
          this.selectedItem.reffield8.push(element.reffield8);
          this.selectedItem.reffield9.push(element.reffield9);
          this.selectedItem.reffield10.push(element.reffield10);
        });
        yesConstruct = true;
      }
      res(yesConstruct);
    });
  }

  doConstructSerial() {
    // First Check the length of constructSerials
    const xlength = this.constructSerials.length;
    let obj = {
      serialnumbers: '',
      serialgodowncodes: {
        godowncode: '',
        godownname: ''
      },
      reffield2: '',
      reffield3: '',
      reffield4: '',
      reffield5: '',
      reffield6: '',
      reffield7: '',
      reffield8: '',
      reffield9: '',
      reffield10: ''
    };
    if (xlength < 1) {
      for (let i = 0; i < parseFloat(this.selectedItem.qty); i++) {
        obj = {
          serialnumbers: this.selectedItem.serialnumbers[i] ? this.selectedItem.serialnumbers[i] : '',
          serialgodowncodes: {
            godowncode: this.selectedItem.serialgodowncodes[i] ? this.selectedItem.serialgodowncodes[i] : '',
            godownname: this.selectedItem.serialgodownnames[i] ? this.selectedItem.serialgodownnames[i] : ''
          },
          reffield2: this.selectedItem.reffield2[i] ? this.selectedItem.reffield2[i] : '',
          reffield3: this.selectedItem.reffield3[i] ? this.selectedItem.reffield3[i] : '',
          reffield4: this.selectedItem.reffield4[i] ? this.selectedItem.reffield4[i] : '',
          reffield5: this.selectedItem.reffield5[i] ? this.selectedItem.reffield5[i] : '',
          reffield6: this.selectedItem.reffield6[i] ? this.selectedItem.reffield6[i] : '',
          reffield7: this.selectedItem.reffield7[i] ? this.selectedItem.reffield7[i] : '',
          reffield8: this.selectedItem.reffield8[i] ? this.selectedItem.reffield8[i] : '',
          reffield9: this.selectedItem.reffield9[i] ? this.selectedItem.reffield9[i] : '',
          reffield10: this.selectedItem.reffield10[i] ? this.selectedItem.reffield10[i] : ''
        };
        this.constructSerials.push(JSON.parse(JSON.stringify(obj)));
      }
    } else {
      // compare the length with the qty;
      const xqty = parseFloat(this.selectedItem.qty);
      const diff = xqty - xlength;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          this.constructSerials.push(JSON.parse(JSON.stringify(obj)));
        }
      } else if (diff < 0) {
        const xnum = diff * -1;
      }
    }
  }

  getDataEdit(val, xic, restore, xbc) {
    this.CloadingTrue = val;
    // Getting the Item Details Data
    this.data.getData('item/' + xic + '/withdetails').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.itemDetails = this.responseData.data;
        this.selectedItem.ina = this.itemDetails.ina;
        if (restore) {
          this.getItemRestoreData(this.CloadingTrue, xic, xbc);
        } else {
          this.CloadingTrue = false;
          this.callPopupfnEdit();
        }

      } else {
        this.clearItemDetails();
      }
    }, (error) => {
      this.CloadingTrue = false;
    });
  }

  callPopupfnEdit() {
    if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'YES') {
      this.getSerialItem(true);

    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
      this.getStockReqNoItem();

    }
  }

  getMatrix(): void {
    const dialogRef = this.dialog.open(MatrixSelectionComponent, {
      width: '900px',
      data: {
        ic: this.selectedItem.ic,
        ina: this.selectedItem.ina,
        matrix1code: this.selectedItem.matrix1code,
        matrix2code: this.selectedItem.matrix2code,
        matrix3code: this.selectedItem.matrix3code,
        matrix4code: this.selectedItem.matrix4code,
        matrix5code: this.selectedItem.matrix5code,
        matrix6code: this.selectedItem.matrix6code,
        matrix7code: this.selectedItem.matrix7code,
        matrix8code: this.selectedItem.matrix8code,
        matrix9code: this.selectedItem.matrix9code,
        matrix10code: this.selectedItem.matrix10code,
        matrixsetup: this.itemDetails.matrixsetup
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.matrix1code = result.selectedbill.matrix1code;
        this.selectedItem.matrix2code = result.selectedbill.matrix2code;
        this.selectedItem.matrix3code = result.selectedbill.matrix3code;
        this.selectedItem.matrix4code = result.selectedbill.matrix4code;
        this.selectedItem.matrix5code = result.selectedbill.matrix5code;
        this.selectedItem.matrix6code = result.selectedbill.matrix6code;
        this.selectedItem.matrix7code = result.selectedbill.matrix7code;
        this.selectedItem.matrix8code = result.selectedbill.matrix8code;
        this.selectedItem.matrix9code = result.selectedbill.matrix9code;
        this.selectedItem.matrix10code = result.selectedbill.matrix10code;
        this.viewRatewiseStock();
      }
    });
  }
}
